import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter';
import config from '../config';

let typesenseAdapter;

/**
 * Collection query parameters should be defined here. As well as the fields that are to be displayed in the search results.
 *
 * Avoid including fields that are not used in the search results, as this will increase the size of the search results for no purpose and cost more money.
 *
 * infix must be set to 'off' for all fields except the one that is used for searching defined in the collection schema
 */
const collectionSpecificSearchParameters = {
  purchases: {
    queryBy: 'uuid, customer_first_name, customer_last_name, customer_email, customer_phone',
    infix: 'off, off, off, always, always',
    includeFields:
      'rafflebox_id, created_at, uuid, goldrush_subscription_id, customer_first_name, customer_last_name, customer_email, customer_phone, total_amount_cents, payment_status_id, organization_group_id',
    facetBy: 'payment_status_id, batch_id, device_id, organization_group_id'
  },
  order: {
    queryBy: 'uuid, subscription_id, first_name, last_name, email, phone, postal',
    queryByWeights: '3,1,2,2,5,4,3',
    infix: 'off, off, always, always, always, always, off',
    numTypos: 0,
    includeFields:
      'rafflebox_id, created_at, uuid, subscription_id, first_name, last_name, email, phone, amount_paid, status'
  }
};

/**
 * Production Typesense is configured with load balancing which allows for high availability and redundancy when making version updates.
 *
 * https://typesense.org/docs/guide/running-in-production.html#configuration
 */
const productionNearestNode = {
  host: 'nqh5yrckl96gdxmwp.a1.typesense.net',
  port: '443',
  protocol: 'https'
};

const productionNodes = [
  {
    host: 'nqh5yrckl96gdxmwp-1.a1.typesense.net',
    port: '443',
    protocol: 'https'
  },
  {
    host: 'nqh5yrckl96gdxmwp-2.a1.typesense.net',
    port: '443',
    protocol: 'https'
  },
  {
    host: 'nqh5yrckl96gdxmwp-3.a1.typesense.net',
    port: '443',
    protocol: 'https'
  }
];

/**
 * Test Typesense is configured with a single node for simplicity and cost reduction.
 */
const testNodes = [
  {
    host: '5wcsfbzrto7vhixkp-1.a1.typesense.net',
    port: '443',
    protocol: 'https'
  }
];

export const initializeTypesense = async () => {
  console.log('[Typesense] Initializing Typesense Adapter');

  if (config.ENV == 'production') {
    typesenseAdapter = new TypesenseInstantSearchAdapter({
      server: {
        apiKey: config.TYPESENSE_API_KEY,
        nearestNode: productionNearestNode,
        nodes: productionNodes,
        cacheSearchResultsForSeconds: 5 * 60 // Cache search results for 5 minutes
      },
      collectionSpecificSearchParameters: collectionSpecificSearchParameters
    });
  } else {
    typesenseAdapter = new TypesenseInstantSearchAdapter({
      server: {
        apiKey: config.TYPESENSE_API_KEY,
        nodes: testNodes,
        cacheSearchResultsForSeconds: 5 * 60 // Cache search results for 5 minutes
      },
      collectionSpecificSearchParameters: collectionSpecificSearchParameters
    });
  }

  console.log('[Typesense] Adapter initialized');
};

export { typesenseAdapter };
